import { IPermission, IPermissionApplication, IPermissionCollection } from 'src/types';
import { fetch } from '../fetchWrapper/fetch';
import { API_URL } from 'src/constants';

export interface GetPermissionsResponse {
  data: {
    applications: IPermissionApplication[];
    collections: IPermissionCollection[];
    permissions: IPermission[];
  };
}

export const getPermissions = async (): Promise<GetPermissionsResponse> => {
  const uri = `${API_URL}/admin/permissions`;

  const response = await fetch(uri);
  if (!response.ok) {
    const responseBody = await response.json().catch(() => null);
    throw new Error(responseBody?.message || 'Could not fetch permissions');
  }
  const responseBody = await response.json();
  return responseBody;
};
